<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-accounting-statement-dialog"
        top="5vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <span v-if="year">{{ year - 1911 }}年會計作業紀錄</span>
        </template>
        <div class="action-bar">
            <div>
                <label style="margin-right: 10px;">金額為 0 的科目：</label>
                <el-radio-group v-model="isShowZeroItems" @change="updateData">
                    <el-radio :label="true">顯示</el-radio>
                    <el-radio :label="false">隱藏</el-radio>
                </el-radio-group>
            </div>
            <el-button @click="updateData">重新整理</el-button>
        </div>
        <div class="container">
            <div class="table-view-container">
                <TableView
                    ref="table"
                    :isLoading="isLoading"
                    :displayMode="1"
                    :queryYear="year"
                    :startDateTxt="startDateTxt"
                    :endDateTxt="endDateTxt"
                    :monthlyTableData="monthlyTableData"
                    :tableData="tableData"
                    :todayDateTxt="todayDateTxt"
                    :isStartEndDateSameYear="true"
                    :settlementDateTxt="settlementDateTxt"
                    :closedDateTxt="closedDateTxt"
                    @click="onClickItem"
                />
            </div>
        </div>
        <DetailDialog
            :visible="detailDialog.visible"
            :StartDate="queryParams.StartDate"
            :EndDate="queryParams.EndDate"
            :accno="detailDialog.accno"
            :accnam="detailDialog.accnam"
            @close="onDetailDialogClose"
        />
    </el-dialog>
</template>

<script>
import moment from 'moment';
import TableView from '@/components/dashboard/Accounting/AccountingStatement/TableView.vue';
import { fetchNormalRowDatas, updateTableData } from '@/components/dashboard/Accounting/AccountingStatement/utils';

export default {
    components: {
        TableView,
        DetailDialog: () => import('@/components/ui/ahAccountingGeneralLedgerDialog.vue'),
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isLoading: false,
            isShowZeroItems: true,
            queryParams: {
                StartDate: null,
                EndDate: null,
            },
            tableData: [],
            monthlyTableData: [],
            annualAccountingTaskStatus: null,
            settlementDate: null,
            closedDate: null,
            openDate: null,
            detailDialog: {
                visible: false,
                accno: null,
                accnam: null,
            },
        };
    },
    computed: {
        todayDateTxt() {
            return moment().format('YYYY年MM月DD日');
        },
        settlementDateTxt() {
            return this.settlementDate ? moment(this.settlementDate).format('YYYY年MM月DD日') : null;
        },
        closedDateTxt() {
            return this.annualAccountingTaskStatus === 2 && this.closedDate ? moment(this.closedDate).format('YYYY年MM月DD日') : null;
        },
        startDateTxt() {
            const DATE = moment(+this.queryParams.StartDate);
            return `${DATE.year() - 1911}年${DATE.format('MM月DD日')}`;
        },
        endDateTxt() {
            const DATE = moment(+this.queryParams.EndDate);
            return `${DATE.year() - 1911}年${DATE.format('MM月DD日')}`;
        },
    },
    methods: {
        async onOpen() {
            this.queryParams.StartDate = moment().year(this.year).startOf('year').format('x');
            this.queryParams.EndDate = moment().year(this.year).endOf('year').format('x');
            await this.updateData();
        },
        async updateData() {
            this.isLoading = true;

            try {
                // 取得資料
                const rawData = await fetchNormalRowDatas(this.queryParams.StartDate, this.queryParams.EndDate);

                // 整理資料
                this.tableData = updateTableData(rawData, this.isShowZeroItems);

                // 結算日期、關帳日期
                this.annualAccountingTaskStatus = rawData.annualAccountingTaskStatus;
                this.settlementDate = rawData.lastSettlementBelongDate;
                this.closedDate = rawData.lastClosedOperationTime;
            } finally {
                this.isLoading = false;
            }
        },
        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            if (refresh) this.updateData();
        },
        onClickItem(item) {
            if (!item.level) return;

            this.detailDialog.accno = item.id;
            this.detailDialog.accnam = item.name;
            this.detailDialog.visible = true;
        },
        async onBeforeClose() {
            this.openDate = null;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-accounting-statement-dialog {
    &.ah-detail-dialog .el-dialog {
        max-width: 1100px;
        background-color: #f6f6f6;
    }
    .action-bar {
        padding: 10px 20px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .table-view-container {
        background-color: #fff;
        padding: 40px 20px;
        border: 1px solid #eee;
        border-radius: 8px;
    }
    .container {
        padding: 40px;
    }
    .right {
        text-align: right;
        margin: 0 20px 20px;
    }
    .pagination {
        text-align: center;
        padding: 40px 0 20px;
    }
}
</style>
